import { forwardRef } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

// TODO: replace `IconEditPencil` and `IconEditDraftVariation` with this icon
export const IconPen16 = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 16 16"
    data-fill-none
  >
    <path
      d="M13.9442 2.05579C13.7455 1.85793 13.5095 1.7014 13.25 1.59524C12.9904 1.48909 12.7124 1.43541 12.432 1.4373C12.1516 1.4392 11.8743 1.49664 11.6162 1.6063C11.3581 1.71596 11.1243 1.87568 10.9283 2.07621L2.47 10.5345L1.4375 14.5625L5.46542 13.5294L13.9237 5.07104C14.1243 4.87512 14.2841 4.64138 14.3938 4.38334C14.5035 4.12529 14.561 3.84806 14.5629 3.56768C14.5648 3.28729 14.5111 3.00931 14.4049 2.7498C14.2987 2.4903 14.1421 2.25441 13.9442 2.05579Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6875 2.31836L13.6823 5.31319"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
));
IconPen16.displayName = 'IconPen16';
